import {createAction, props} from '@ngrx/store';

export const addNavigationHistory = createAction('[Routing] Add Navigation History', props<{url: string}>());
